import { Button } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from 'constants/events';
import { LOOM_URI } from 'constants/routes';
import { SHARE_VIDEO_CARD_KEY } from 'constants/workspaceOnboarding';
import * as analytics from 'utilities/analytics';

import useClipboard from 'hooks/useClipboard';
import { useGetSelectedWorkspace } from 'hooks/workspace';

import DashboardOnboardingCard from '../..';

import { ShareVideoSvg } from 'components/videos-dashboard-ta/empty-library-ta/icons';
import { dismissElementHandler } from 'components/welcome-modal';

const MOST_RECENT_VIDEO = `${LOOM_URI}/most-recent-video`;

const ShareVideoCard = ({ cardConfig }) => {
  const dispatch = useDispatch();
  const [isCopied, setCopied] = useClipboard(MOST_RECENT_VIDEO);
  const header = 'Share your video';
  const description =
    'Send your latest recording to a teammate via a link or in an app.';

  const selectedWorkspace = useGetSelectedWorkspace();

  if (!selectedWorkspace) {
    return null;
  }

  const primaryAction = (
    <Button
      onClick={() => {
        setCopied();

        setTimeout(() => {
          dismissElementHandler(
            dispatch,
            SHARE_VIDEO_CARD_KEY,
            selectedWorkspace.id
          );

          analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
            type: 'primary',
            card: SHARE_VIDEO_CARD_KEY,
          });
        }, 2000);
      }}
    >
      {isCopied ? 'Link copied!' : 'Copy last video link'}
    </Button>
  );

  return (
    <DashboardOnboardingCard
      cardKey={SHARE_VIDEO_CARD_KEY}
      cardConfig={cardConfig}
      heading={header}
      description={description}
      centerpiece={<ShareVideoSvg />}
      primaryAction={primaryAction}
    />
  );
};

export default ShareVideoCard;
